import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["appKey", "mpacBaseUrl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TRUST_DATA_FORM_STATES } from '@atlassian/mpac-api-client';
import { H4 } from '@atlassian/mpac-primitives';
import React from 'react';
import { PrivacySecurityDetailsNotAvailableBannerContainer, PrivacySecurityDetailsNotAvailableBannerContent } from '../../CustomerPrivacyAndSecurityTab/CustomerPrivacyAndSecurityTab.styles';
import { useAppTrustData } from '../../hooks';
import { getContactPartnerUrl } from '../../utils';
import { ContactPartnerLink } from '../ContactPartnerLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PSDetailsNotAvailableForDCAndServerAppsBanner = _ref => {
  var _appTrustData$securit;
  let {
      appKey,
      mpacBaseUrl
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    appTrustData,
    isPending: appTrustIsPending
  } = useAppTrustData(mpacBaseUrl, appKey, TRUST_DATA_FORM_STATES.LIVE);
  const contactPartnerLinkProps = getContactPartnerUrl(_objectSpread(_objectSpread({}, rest), {}, {
    mpacBaseUrl,
    securityEmailId: !appTrustIsPending ? appTrustData === null || appTrustData === void 0 ? void 0 : (_appTrustData$securit = appTrustData.security) === null || _appTrustData$securit === void 0 ? void 0 : _appTrustData$securit.securityContact : undefined
  }));
  return /*#__PURE__*/_jsxs(PrivacySecurityDetailsNotAvailableBannerContainer, {
    children: [/*#__PURE__*/_jsx(H4, {
      as: "h2",
      children: " Privacy & Security details inapplicable "
    }), /*#__PURE__*/_jsxs(PrivacySecurityDetailsNotAvailableBannerContent, {
      children: ["The privacy and security tab displays information only for cloud apps, which is collected from the respective app partner. It's not applicable for Server and Data Center apps. For any further queries, ", /*#__PURE__*/_jsx(ContactPartnerLink, _objectSpread({}, contactPartnerLinkProps)), "."]
    })]
  });
};